import styled from 'styled-components'

const StandardParagraph = styled.div`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  margin-bottom: 3rem;
  hyphens: auto;
  
  a {
    color: var(--text-color);
    color: inherit;
    text-decoration: none;
    padding: 0.2rem 0 0;
    background-image: linear-gradient(
      to right,
      var(--link-background-color) 0,
      var(--link-background-color) 100%
    );
    background-size: 100% 20%;
    background-position-y: 17px;
    background-repeat: repeat-x;
    background-position: bottom;
    &:hover {
      background-size: 100% 100%;
    }
  }
`
export default StandardParagraph
